(ns app.front.view.group.admin.inspections.visit-result-detail
  (:require [app.domain.inspection.model :as inspection-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.content-switcher :as ui-cs]
            [app.front.ui.i18n :as i18n]
            [app.front.ui.select :as ui-select]
            [app.front.ui.tag-type-editor :as ui-tag-type-editor]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.inspections.db :as iadb]
            [app.front.view.group.admin.inspections.subs :as ias]
            [app.front.view.group.admin.subs :as gas]
            [app.i18n.model :as i18n-model]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx ::create-inspection-result-detail
  (fn [_ [_ authority-group-id visit-result names on-done visits-conf?]]
    {:comm/command {:command    :inspection/create-visit-result-detail
                    :method     :post
                    :data       (cond-> (util/mmap {:data {:visit-result-detail/names names}}
                                                   authority-group-id)
                                  visits-conf? (assoc-in [:data :visit-result-detail/visit-result] (:db/id visit-result))
                                  (not visits-conf?) (assoc-in [:data :visit-result-detail/result] visit-result))
                    :on-success [::create-inspection-result.success on-done]
                    :notify     {:success (if visits-conf? :visit-result-reason/created :visit-result-detail/created)}}}))

(rf/reg-event-fx ::create-inspection-result.success
  (fn [_ [_ on-done status resp]]
    (on-done)
    {:dispatch [::entities/apply-changes status resp]}))

(rf/reg-event-fx ::edit-inspection-result
  (fn [_ [_ visit-result-id names]]
    {:comm/command {:command    :inspection/edit-visit-result-detail
                    :method     :post
                    :data       {:id                        visit-result-id
                                 :visit-result-detail/names names}
                    :on-success [::entities/apply-changes]
                    :notify     {:success :changes-saved}}}))

(rf/reg-event-fx ::delete-inspection-result
  (fn [_ [_ visit-result-id]]
    {:comm/command {:command    :inspection/delete-visit-result-detail
                    :method     :post
                    :data       {:id visit-result-id}
                    :on-success [::entities/apply-changes]
                    :notify     {:success :changes-saved}}}))

(rf/reg-event-fx ::toggle-inspection-result
  (fn [_ [_ visit-result-id enabled?]]
    {:comm/command {:command    :inspection/toggle-visit-result-detail
                    :method     :post
                    :data       (util/mmap {:id visit-result-id} enabled?)
                    :on-success [::entities/apply-changes]
                    :notify     {:success :changes-saved}}}))

(rf/reg-event-fx ::edit-inspection-result-label
  (fn [_ [_ authority-group-id result label]]
    {:comm/command {:command    :inspection/edit-visit-result-detail-label
                    :method     :post
                    :data       (util/mmap {:result (if (keyword? result) result (:db/id result))}
                                           authority-group-id label)
                    :on-success [::entities/apply-changes]
                    :notify     {:success :changes-saved}}}))

(rf/reg-sub ::visit-result-detail-entities
  (fn [[_ group-id result]]
    (let [query {:entity/type            :entity.type/visit-result-detail
                 :domain/authority-group group-id}]
      [(rf/subscribe [::entities/entities (if (keyword? result)
                                            (assoc query :visit-result-detail/result result)
                                            (assoc query :visit-result-detail/visit-result (:db/id result)))])
       (rf/subscribe [::ff/enabled? :feature-flag.id/inspection-visit-configuration])]))
  (fn [[results show-failure-reasons?] _]
    (->> results
         ((inspection-model/filter-applicable-reasons-fn show-failure-reasons?)))))

(rf/reg-sub ::visit-result-detail-label-entity
  (fn [[_ group-id result]]
    (let [query {:entity/type                     :entity.type/visit-result-detail-label
                 :visit-result-detail-label/group group-id}]
      (rf/subscribe [::entities/entity (if (keyword? result)
                                         (assoc query :visit-result-detail-label/result result)
                                         (assoc query :visit-result-detail-label/visit-result (:db/id result)))])))
  (fn [result-detail-label _] result-detail-label))

(rf/reg-sub ::visit-result-details
  (fn [[_ group-id result]]
    (rf/subscribe [::visit-result-detail-entities group-id result]))
  (fn [entities _]
    (->> entities
         (map #(select-keys % [:db/id
                               :entity/type
                               :visit-result-detail/names
                               :domain/state]))
         (map #(update % :visit-result-detail/names i18n-model/strings-map)))))

(rf/reg-sub ::enabled-result-detail-id-set
  (fn [[_ group-id result]]
    (rf/subscribe [::visit-result-details group-id result]))
  (fn [extras _]
    (->> extras
         (filter du/is-active?)
         (map :db/id)
         set)))

(rf/reg-sub ::result-details-in-use
  (fn [db _]
    (or (::iadb/result-details-in-use db)
        #{})))

(rf/reg-sub ::selected-result
  (fn [db [_ default]]
    (::selected-result db default)))

(rf/reg-event-db ::select-result
  (fn [db [_ result]]
    (assoc db ::selected-result result)))

(defn editor-for-type [{:keys [authority-group-id tr result visits-conf?]}]
  (when result
    (r/with-let [*value           (r/atom nil)
                 *editor-enabled? (r/atom false)]
      (let [values                        (<sub [::visit-result-details authority-group-id result])
            at-least-one-reason-required? (or (-> result :inspection-visit-result/rules (contains? :inspection.visit.result-rule/reason-required) not)
                                              (-> values count (> 1)))]
        [ui-tag-type-editor/editor
         (util/mmap {:values             values
                     :name-attr          :visit-result-detail/names
                     :tag-type-name      (tr [(if visits-conf? :visit-result-reason/tag-type-name :visit-result-detail/tag-type-name)])
                     :on-create          (fn [{:keys [names on-done]}]
                                           (>evt [::create-inspection-result-detail authority-group-id result names on-done visits-conf?]))
                     :on-end-edit        (fn [{:keys [:db/id :visit-result-detail/names]}]
                                           (>evt [::edit-inspection-result id names]))
                     :on-toggle-editor   (partial reset! *editor-enabled?)
                     :on-delete          (when at-least-one-reason-required?
                                           (fn [{:keys [:db/id]}]
                                             (>evt [::delete-inspection-result id])))
                     :on-toggle          (when at-least-one-reason-required?
                                           (fn [enabled? {:keys [:db/id]}]
                                             (>evt [::toggle-inspection-result id enabled?])))
                     :selected?          (comp (<sub [::enabled-result-detail-id-set authority-group-id result]) :db/id)
                     :edit-disabled?     (comp (<sub [::result-details-in-use]) :db/id)
                     :additional-element [i18n/localized-string-edit
                                          {:id                  "detail-label-editor"
                                           :tr                  tr
                                           :label-text          (tr [(if visits-conf? :visit-result-reason/detail-label :visit-result-detail/detail-label)])
                                           :strings             (or @*value
                                                                    (-> (<sub [::visit-result-detail-label-entity authority-group-id result])
                                                                        :visit-result-detail-label/text
                                                                        i18n-model/strings-map))
                                           :disabled            (not @*editor-enabled?)
                                           :on-change           (fn [input]
                                                                  (reset! *value input))
                                           :on-end-edit         (fn []
                                                                  (>evt [::edit-inspection-result-label authority-group-id result @*value])
                                                                  (reset! *value nil))
                                           :allowed-locales-sub ::gas/allowed-locales}]}
                    tr)]))))

(defn view [{:keys [authority-group-id tr]}]
  (let [visits-conf?  (<sub [::ff/enabled? :feature-flag.id/inspection-visit-configuration])
        lang          (<sub [:language])
        visit-results (<sub [::ias/visit-result-entities authority-group-id])
        result        (<sub [::selected-result (if visits-conf?
                                                 (first visit-results)
                                                 (first inspection-model/visit-results))])]
    [acommon/section
     {}
     [acommon/admin-config-form
      [ui/help (tr [(if visits-conf? :visit-result-reason/editor-help :visit-result-detail/editor-help)])]
      (if visits-conf?
        [ui-select/select {:values       visit-results
                           :allow-empty? false
                           :val->str     #(inspection-model/visit-result-name % lang)
                           :label-text   (tr [:visit-result-reason/visit-result])
                           :id           "reason-visit-result"
                           :on-change    #(>evt [::select-result %])
                           :value        result}]
        [ui-cs/content-switcher {:items     inspection-model/visit-results
                                 :val->str  (comp tr vector)
                                 :current   result
                                 :on-change #(>evt [::select-result %])
                                 :class     "mb-4"}])
      [editor-for-type (util/mmap result authority-group-id tr visits-conf?)]]]))
